import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const state = {
  isUploading: false,
  meta: {}
}

const mutations = {
  setUploading: (state, status) => {
    state.isUploading = !!status;
  }
}

export default createCrudModule({
  client: api.client,
  resource: 'documents',
  parseList: res => res.data,
  parseSingle: res => res.data,
  onFetchListSuccess: (state, { meta }) => {
    if (meta) state.meta = meta;
  },
  customUrlFn: (id, params) => `/projects/${params.project_id}/invoices/${params.invoice_id}/documents${id ? '/'+id : ''}`,
  state,
  mutations
});